module.exports = __webpack_public_path__ + "static/media/CompoundShape1.4886f85a.jpg";